import { ZOOMTO} from './ZoomToTypes'

const initialState = {
    nodesTo: {
        name: "",
        oggetto: "",
        visible: false,
        opacity: 1
    }
}

const zoomTo = (state = initialState, action) => {
    
    switch (action.type) {
        case ZOOMTO:
            
            return {
                nodesTo: action.load
            }
    
        default:
          return state
    }

}

export default zoomTo;
